import React from 'react';
import { useComponents } from '@tencent/dz-elements';
export var Header = function (props) {
    var View = useComponents().View;
    return (React.createElement(View, { className: "header", style: { zIndex: 999, boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)' } }, props.children));
};
